module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'field field--' + _vm.type,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeText($event)
      },
      "blur": _vm.changeText
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffix"
  }, [_c('icon', {
    attrs: {
      "name": "Search-white",
      "scale": 1.5
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f77a83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/TextInput.vue
// module id = 950
// module chunks = 0